import axios from "axios";

// Production: always use HTTPS. Never use http:// or localhost in production (causes "Not secure" / mixed content).
const PRODUCTION_API = "https://api.smartinvestments.online/api";
const DEV_API = "http://localhost:5000/api";

function getBaseURL() {
  if (process.env.NODE_ENV === "production") {
    const url = process.env.REACT_APP_API_URL || "";
    const trimmed = url.replace(/\/$/, "").trim();
    const isInsecure = !/^https:\/\//i.test(trimmed);
    const isLocalhost = /localhost|127\.0\.0\.1/i.test(trimmed);
    if (!trimmed || isInsecure || isLocalhost) {
      return PRODUCTION_API;
    }
    return `${trimmed}/api`;
  }
  if (process.env.REACT_APP_API_URL) {
    return `${process.env.REACT_APP_API_URL.replace(/\/$/, "")}/api`;
  }
  return DEV_API;
}

export const api = axios.create({
  baseURL: getBaseURL(),
});
